<div style="padding: 0 1rem;" *ngIf="teamMaxDetails.controls.length" [formGroup]="teamMaxForm">
    <table formArrayName="teamMaxDetails" class="alternateColor" [ngClass]="switchInput?'':'disabledColor'"
        aria-describedby="capacityTable">
        <th id="header">
            <tr class="fixed-row">
                <td>
                    <div class=" form-control  border-0">{{'departmentCapacity.teams'| translate}}</div>
                </td>
            </tr>
            <tr class="fixed-row row2">
                <td>
                    <div class=" form-control  border-0" style="font-size : 0.55rem"></div>
                </td>
            </tr>
            <tr class="fixed-row row3"> 
                <td>
                    <div class=" form-control  border-0">{{'departmentCapacity.total'| translate}}</div>
                </td>
            </tr>
            <tr *ngFor="let team of teams$">
                <td>
                    <div class=" form-control  border-0">{{team.name}}</div>
                </td>
            </tr>
        </th>

        <td *ngFor="let day of teamMaxDetails.controls; let i = index" [formGroupName]="i">
            <div class="fixed-row">
                <tr class="center-items-fix">
                    <td>
                        <div class=" form-control border-0" style="margin-left: -0.5rem !important;">{{getWeekDays(day.value.dayOfWeek)}}</div>
                    </td>
                </tr>
                <tr class="center-items-fix">
                    <td>
                        <div class=" form-control border-0 operation-hours" style="margin-left: -0.5rem !important;">{{day.value.hoursOfOperation === 'Closed' ? ('departmentCapacity.closed'| translate): day.value.hoursOfOperation   }}</div>
                    </td>
                </tr>
                <tr class="center-items-fix">
                    <td>
                        <div class="form-control  border-0" style="margin-left: 0.5rem !important;">
                            {{slotTotals[day.value.dayOfWeek]}}
                            <span *ngIf="slotTotals[day.value.dayOfWeek] && slotTotals[day.value.dayOfWeek] != 0"
                                class="cap-indicator"
                                [ngStyle]="{ 'background-image':!switchInput?'url('+ slotTotalStatus[day.value.dayOfWeek].split('.svg')[0]+'-disable'+'.svg' +')' :'url('+ slotTotalStatus[day.value.dayOfWeek] +')' }">
                            </span>
                        </div>
                    </td>
                </tr>
            </div>
            <div *ngIf="viewMode === 'Team'">
                <tr *ngFor="let team of teams$; let j = index" formArrayName="capacities">
                    <td [formGroupName]="j">
                        <input [readonly]="day.value.hoursOfOperation === 'Closed'||!switchInput" [ngClass]="day.value.hoursOfOperation === 'Closed' ?'disabled-field':''" type="number" min="0"
                            class="form-control" formControlName="capacity" />
                    </td>
                </tr>
            </div>
            <div *ngIf="viewMode !== 'Team'">
                <tr *ngFor="let team of teamCapacity;">
                    <td>
                        <input [readonly]="true" type="text" class="form-control"
                            value="{{getTableValue(team.capacity,day.value.dayOfWeek)}}" />
                    </td>
                </tr>
            </div>
        </td>
    </table>

    <div class="controls" *ngIf="viewMode === 'Team'">
        <div class="cancel" [ngClass]="isSaveClicked ? 'enabled' : ''" (click)="onCancel()">{{ 'overrideCapacity.cancel' | translate }}</div>
        <div class="save" [ngClass]="isSaveClicked ? 'enabled' : ''" (click)="onSave()">{{ 'overrideCapacity.save' | translate }}</div>
    </div>
</div>
